var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.49 17.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#1db2d7;}.cls-1{stroke:#1db2d7;stroke-miterlimit:10;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.67.25H2.82A2.57,2.57,0,0,0,.25,2.82V15.53A1.85,1.85,0,0,0,2.1,17.38H7.82a1.85,1.85,0,0,0,1.85-1.85V5.39h5.14V15.53a1.85,1.85,0,0,0,1.86,1.85h5.72a1.85,1.85,0,0,0,1.85-1.85V2.82A2.57,2.57,0,0,0,21.67.25ZM2,2.82A.87.87,0,0,1,2.82,2H21.67a.86.86,0,0,1,.85.86v.86H2ZM8,15.53a.14.14,0,0,1-.14.14H2.1A.14.14,0,0,1,2,15.53H2v-5H8ZM8,8.82H2V5.39H8ZM22.52,5.39V8.82h-6V5.39Zm0,10.14a.13.13,0,0,1-.13.14H16.67a.14.14,0,0,1-.14-.14h0v-5h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.53,8h.86a.86.86,0,1,0,0-1.71H4.53A.86.86,0,0,0,4.53,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.53,14h.86a.86.86,0,1,0,0-1.72H4.53a.86.86,0,0,0,0,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.1,8H20a.86.86,0,1,0,0-1.71H19.1A.86.86,0,1,0,19.1,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.1,14H20a.86.86,0,0,0,0-1.72H19.1a.86.86,0,1,0,0,1.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/Desk.2c46cca987090284b035e13eaa7eb027.svg";
export { ForwardRef as ReactComponent };